export default "__VITE_ASSET__3tkt537pGNF25_4N$ZWl6Q__";